export default "__VITE_ASSET__CiM9h90u__"